import React, { useEffect, useMemo, useState } from 'react'
import { ArrowLeft, Plus, Save, Search, Slash, Trash2 } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { startChangeState, startCloseSale, startloadSale, startloadSales } from '../../../../app/store/sales/thunks';
import { NewAnticipo } from '../../orderTracking/modals/NewAnticipo';
import Swal from 'sweetalert2';
import { loadCliente } from '../../../../app/store/clientes/thunks';
import { useForm } from 'react-hook-form';
import { AddFacturacion } from '../../customers/modals/AddFacturacion';
import { SearchFacturacion } from '../../orderClose/modals/SearchFacturacion';
import { CardCobroVenta } from '../../sales/shared/CardCobroVenta';
import { closeSalesByOrder } from '../../../../app/store/ordenes/thunks';


export const EditSale = () => {

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
        didOpen: (toast) => {
            // toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });


    const { sale_edit, status, isLoading } = useSelector(state => state.ventasPedido);
    const { descuentos, tipos_pagos, servicios, productosAlm, } = useSelector(state => state.catalogos);
    const { cliente_edit } = useSelector(state => state.clientes);
    const { usuario, id_emp } = useSelector(state => state.usuario);
    const dispatch = useDispatch();
    const [Pagos, setPagos] = useState([]);

    const capturante = usuario;
    const { register: registerCC, trigger: triggerCC, setFocus: setFocusCC, getValues: getValuesCC, setValue: setValueCC, formState: { errors: errorsCC }, handleSubmit: handleSubmitCC, reset: resetCC } = useForm(
        {
            mode: 'all',
            defaultValues: {}
        });


    const goback = () => {
        dispatch(startloadSales());
    }

    const handleChange = (e, folio) => {
        let estado = e.target.value;
        Swal.fire({
            title: 'Atención',
            text: "Está por cambiar de Estado de la Compra por Pedido, ¿Desea de continuar con esta acción?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3b7ddd',
            cancelButtonColor: '#dc3545',
            cancelButtonText: 'No',
            confirmButtonText: 'Si'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(startChangeState(folio, estado));
            } else {
                // dispatch(startloadOrden(folio));
                dispatch(startloadSale(folio));
                dispatch(loadCliente(cliente_edit.cliente_id));
            }
        })
    }

    let sale = sale_edit[0];
    let anticipos = sale["ANTICIPOS"];
    let anticipos2 = sale["ANTICIPOS_2"];
    let total_anticipos = 0;

    if (anticipos.length != 0) {
        anticipos.forEach(item => {
            total_anticipos = total_anticipos + Number(item.MONTO);
        });
    } else {
        total_anticipos = anticipos2[0]?.MONTO;
    }


    const [datosCobro, setDatosCobro] = useState({
        pagos: [],
        productos: [],
        iva: 0,
        total: 0,
        totalPagado: 0,
        subtotal: 0,
        cambio: 0,
        faltante: 0,
        typeSale: 0
    });

    const handleUpdateCobro = (data) => {

        setDatosCobro(prev => ({ ...prev, ...data }));
    };

    const cancel = () => {
        dispatch(startloadSales());
    }

    const closeOrden = () => {

        let idCliente = sale.CLIENTE_ID;

        let flagFacturacion = 0; let idFacturacion = 0; let flagSpecial = 3;

        const { pagos, productos, total, totalPagado, subtotal, faltante, iva, cambio } = datosCobro;

        if (productos.length === 0) {
            Toast.fire({ icon: 'error', title: 'Debe agregar productos, para la venta.' });
            return;
        }

        if (faltante > 0) {
            Toast.fire({ icon: 'error', title: 'Debe realizar el cobro correspondiente para la venta.' });
            return;
        }

        const payload = {
            idCliente: idCliente,
            idFacturacion: idFacturacion,
            flagFacturacion: flagFacturacion,
            flagSpecial: flagSpecial,
            capturo: capturante,
            total: total,
            iva: iva,
            subtotal: subtotal,
            pagado: totalPagado,
            cambio: cambio,
            detailPagos: pagos,
            productos: productos
        };

        Swal.fire({
            title: 'Atención',
            text: `Está por finalizar una venta por pedido. ¿Desea continuar?`,
            icon: 'warning',
            showCancelButton: true,
            showCancelButton: true, confirmButtonText: 'Si, continuar', cancelButtonText: 'No, cancelar',
            customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-secondary ms-2' }, buttonsStyling: false
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(closeSalesByOrder(payload,sale.FOLIO));
            }
        });
    }


    const productosParaCobro = useMemo(() => [{
        ID: sale.FOLIO,
        NOMBRE: sale.PRODUCTO,
        DESCRIPCION: sale.DESCRIPCION,
        COSTO_PUBLICO: (Number(sale.COSTO) - Number(total_anticipos)).toFixed(2),
        CANTIDAD: 1
    }], [sale.FOLIO, sale.PRODUCTO, sale.DESCRIPCION, sale.COSTO, total_anticipos]);


    if (isLoading) {
        return (
            <>
                <div className='div_center'>
                    <div className='text-center'>
                        <div className="spinner"></div>
                    </div>
                    <div className='text-center text-left-15'>
                        <span className='fw-bold'>Cargando</span>
                    </div>
                    <div className='text-center text-left-15'>
                        <div className="spinner"></div>
                    </div>
                </div>
            </>
        )
    }


    return (
        <>
            <NewAnticipo folio={sale.FOLIO} />
            {/* <AddFacturacion /> <SearchFacturacion /> */}
            <div className='row'>
                <div className='col-12'>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item btn-link" onClick={goback}><ArrowLeft size='20' /> Atras</li>
                            <li className="breadcrumb-item active" aria-current="page">Detalles de Venta por Pedido</li>
                        </ol>
                    </nav>
                </div>

                <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-3">
                    <div className="card ">
                        <div className="card-body">
                            <label className="mb-1 fw-bold text-dark">Venta por pedido:</label>
                            <div className="d-flex">
                                <input className="form-control me-2" type="search" aria-label="Search" disabled defaultValue={sale.FOLIO} />

                            </div>

                        </div>
                        <hr className="my-0" />
                        <div className="card-body">

                            <div className="row mb-1">
                                <div className="col-12">
                                    <h5 className="fw-bold me-2 border-0">Datos del Cliente </h5>
                                </div>

                            </div>
                            <hr className="my-0" />

                            <div className="row">
                                <div className="col-12 mt-3">
                                    <div className="mb-1">
                                        <label className="form-label">Nombre:</label>
                                        <input type="text" className="form-control" defaultValue={cliente_edit.NOMBRE} disabled />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="mb-1">
                                        <label className="form-label">Telefono:</label>
                                        <input type="text" className="form-control" defaultValue={cliente_edit.TELEFONO} disabled />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="mb-1">
                                        <label className="form-label">Celular:</label>
                                        <input type="text" className="form-control" defaultValue={cliente_edit.CELULAR} disabled />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="mb-3">
                                        <label className="form-label">Correo electronico:</label>
                                        <input type="text" className="form-control" defaultValue={cliente_edit.EMAIL} disabled />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-9'>
                    <div className="card">
                        <div className="card-body">
                            <div className="row mb-3">
                                <div className='col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
                                    <h5 className="card-title fw-bold text-dark mb-2 mt-1">Detalles del Pedido </h5>
                                    <button type="button" className="btn btn-outline-primary me-2" data-bs-toggle="modal" data-bs-target="#newAnticipo">
                                        Agregar anticipo
                                    </button>
                                </div>
                                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4  ">
                                    <label className="mb-1">Estado Pedido:</label>
                                    <select className="form-select " defaultValue={sale.ESTADO} onChange={e => handleChange(e, sale.FOLIO)}>
                                        <option value={1}>Espera</option>
                                        <option value={2}>Solicitada</option>
                                        <option value={3}>Llego / Recibida</option>
                                        <option value={4}>Entrega a Cliente</option>
                                    </select>
                                </div>

                                <div className='col-4 col-sm-4 col-md-3 col-lg-3 col-xl-3 col-xxl-3 mt-2'>
                                    <h5 className="mt-4"> Total de Anticipos:
                                        <span className="fw-bold text-left-10">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(total_anticipos)}</span>
                                    </h5>
                                </div>
                            </div>
                            <hr />

                            <div className="row mb-3">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="mb-2">
                                            <label className="form-label">Producto:</label>
                                            <input type="text" className="form-control" disabled defaultValue={sale.PRODUCTO} />
                                        </div>
                                    </div>

                                    <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                                        <div className="mb-2">
                                            <label className="form-label">Fecha Sol:</label>
                                            <input type="text" className="form-control" aria-label="First name" autoComplete='off' disabled defaultValue={sale.FECHA} />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                                        <div className="mb-2">
                                            <label className="form-label">Hora Sol:</label>
                                            <input type="text" className="form-control" aria-label="First name" autoComplete='off' disabled defaultValue={sale.HORA_SOL} />
                                        </div>
                                    </div>

                                    <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                                        <div className="mb-2">
                                            <label className="form-label">Costo:</label>
                                            <input type="number" className="form-control" aria-label="First name" autoComplete='off' disabled defaultValue={sale.COSTO} />
                                        </div>
                                    </div>

                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                                        <div className="mb-2">
                                            <label className="form-label">Descripcion:</label>
                                            <textarea className="form-control" rows="6" disabled defaultValue={sale.DESCRIPCION}></textarea>

                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                                        <div className="mb-2">
                                            <label className="form-label">Enlace:</label>
                                            <textarea className="form-control" rows="6" disabled defaultValue={sale.ENLACE} ></textarea>

                                        </div>
                                    </div>
                                </div>

                            </div>
                            {
                                sale.ESTADO == 4 ?
                                    <>

                                        {/* Aqui va el componente para cobrar */}

                                        <div className='row' >
                                            <CardCobroVenta listProducts={productosParaCobro} listPaymentMethods={tipos_pagos} onUpdate={handleUpdateCobro} precioIncluyeIVA={true} />
                                        </div>
                                        <div className="text-end">
                                            <button type="button" className="btn btn-outline-danger mt-2"
                                                onClick={cancel}
                                            >
                                                <Slash size='20' /> Cancelar
                                            </button>
                                            <button type="submit" className="btn btn-outline-primary mt-2 ms-3" onClick={closeOrden}>
                                                <Save size='20' /> Guardar
                                            </button>
                                        </div>

                                    </> : <></>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
